import { StepNavigationSwitch } from '../../atoms/step-navigation-switch';
import { CareCreditCollectBody } from './care-credit-collect-body';
import { CareCreditCollectGenericNavigation } from './navigation/care-credit-collect-generic-navigation';

export const CareCreditCollectNavigationSwitch = () => {
  return <StepNavigationSwitch body={CareCreditCollectBody} generic={CareCreditCollectGenericNavigation} />;
};
